/**
 * @generated SignedSource<<0382a76ec49bed9807777c7d414b2802>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FirstGroupRow756BadPattern$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FirstGroupIssues">;
  readonly " $fragmentType": "FirstGroupRow756BadPattern";
};
export type FirstGroupRow756BadPattern$key = {
  readonly " $data"?: FirstGroupRow756BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"FirstGroupRow756BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FirstGroupRow756BadPattern",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "FirstGroupIssues"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "1d38bbf22873fe55d8d92905369ab52b";

export default node;
